import { PublicLayout } from '@core/components';
import type { RouteObject } from 'react-router-dom';

import { LoginLayout } from './components';
import { ErrorPage, LoginCallbackPage, LoginPage } from './pages';
import { getAuthRoutePaths } from './routes';

/**
 * Get auth domain route configurations for the router
 */
export const getAuthRouteConfig = (): RouteObject[] => {
  const paths = getAuthRoutePaths();

  return [
    {
      path: paths.login,
      element: <LoginLayout />,
      children: [
        {
          index: true,
          element: <LoginPage />,
        },
      ],
    },
    {
      path: paths.loginCallback,
      element: <LoginLayout />,
      children: [
        {
          index: true,
          element: <LoginCallbackPage />,
        },
      ],
    },
    {
      path: paths.notFound,
      element: <PublicLayout />,
      children: [
        {
          index: true,
          element: <ErrorPage />,
        },
      ],
    },
  ];
};
